//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import "@/mixins/global";
import chartOTP from "../../components/chartOTPPurchase";
import axios, { CancelToken } from "axios";
// import ChartOTP from "../components/chartOTP.vue";
export default {
  components: {
    chartOTP,
  },
  data() {
    return {
      chart: {
        ALL: [],
        G1: [],
        G2: [],
        G3: [],
        G4: [],
        GW: [],
        TRM: [],
        VN: [],
      },
      grp: "SCM VI",
      ps: "202001",
      pe: "202053",
      // api: `${this.$apiFix}OTPSCM.php/fabric`,
      api: `${this.$apiFix}`,
    };
  },
  async mounted() {
    let a = await this.defaultPeriod();
    this.loadData();
  },
  methods: {
    goPage(routerName) {
      this.$router.push({
        name: routerName,
      });
    },

    defaultPeriod() {
      let params = new FormData();
      const obj = axios({
        method: "post",
        url: this.$api + "otpmaster.php/otperiod",
        data: params,
      }).then((res) => {
        this.ps = res.data.ps;
        this.pe = res.data.pe;
      });

      return obj;
    },

    loadData() {

      axios
        .get(
          `${this.api}otp_fabric.php/scm?ps=${this.ps}&pe=${this.pe}&loc=`
        )
        .then((response) => {
          this.chart.ALL = response.data;
        });

      axios
        .get(
          `${this.api}otp_fabric.php/scm?ps=${this.ps}&pe=${this.pe}&loc=G1`
        )
        .then((response) => {
          this.chart.G1 = response.data;
        });

      axios
        .get(
          `${this.api}otp_fabric.php/scm?ps=${this.ps}&pe=${this.pe}&loc=G2`
        )
        .then((response) => {
          this.chart.G2 = response.data;
        });

      axios
        .get(
          `${this.api}otp_fabric.php/scm?ps=${this.ps}&pe=${this.pe}&loc=G3`
        )
        .then((response) => {
          this.chart.G3 = response.data;
        });

      axios
        .get(
          `${this.api}otp_fabric.php/scm?ps=${this.ps}&pe=${this.pe}&loc=G4`
        )
        .then((response) => {
          this.chart.G4 = response.data;
        });

      axios
        .get(
          `${this.api}otp_fabric.php/scm?ps=${this.ps}&pe=${this.pe}&loc=GW`
        )
        .then((response) => {
          this.chart.GW = response.data;
        });

      axios
        .get(
          `${this.api}otp_fabric.php/scm?ps=${this.ps}&pe=${this.pe}&loc=TRM`
        )
        .then((response) => {
          this.chart.TRM = response.data;
        });

      axios
        .get(
          `${this.api}otp_fabric.php/scm?ps=${this.ps}&pe=${this.pe}&loc=VN`
        )
        .then((response) => {
          this.chart.VN = response.data;
        });

    },
  },
};
